import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function arabicOnlyValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value?.trim();

    if (!value) return null;

    const arabicRegex = /^[\u0600-\u06FF0-9\s-]+$/;

    return arabicRegex.test(value) ? null : { arabicOnly: true };
  };
}

export function englishOnlyValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value?.trim();

    if (!value) return null;

    const englishRegex = /^[a-zA-Z0-9 '-]+$/;

    return englishRegex.test(value) ? null : { englishOnly: true };
  };
  
}

export function noLeadingTrailingSpacesValidator() {
  return (control: AbstractControl) => {
    const value = control.value;

    if (!value) return null;

    return value.trim() === value
      ? null
      : { spaces: true };
  };
}

export function noNumbersValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value) return null;

    return /\d/.test(value)
      ? { numbers: true }
      : null;
  };
}


export interface CancellationReasonDateValidationResult {
  createdFromDateError: string | null;
  createdToDateError: string | null;
  modifiedFromDateError: string | null;
  modifiedToDateError: string | null;
  isValid: boolean;
}

export function validateCancellationReasonDates(
  createdFrom: string | null,
  createdTo: string | null,
  modifiedFrom: string | null,
  modifiedTo: string | null,
  isArabic: boolean
): CancellationReasonDateValidationResult {

  let createdFromDateError: string | null = null;
  let createdToDateError: string | null = null;
  let modifiedFromDateError: string | null = null;
  let modifiedToDateError: string | null = null;

  const today = new Date();
  if (createdFrom) {
    const fromDate = new Date(createdFrom);

    if (fromDate > today) {
      createdFromDateError = isArabic
        ? 'لا يمكن اختيار تاريخ مستقبلي.'
        : 'Future dates cannot be selected.';
    }
  }

  if (createdTo) {
    const toDate = new Date(createdTo);

    if (toDate > today) {
      createdToDateError = isArabic
        ? 'لا يمكن اختيار تاريخ مستقبلي.'
        : 'Future dates cannot be selected.';
    }
  }

  if (createdFrom && createdTo) {
    const fromDate = new Date(createdFrom);
    const toDate = new Date(createdTo);

    if (fromDate > toDate) {
      const message = isArabic
        ? 'تاريخ البداية لا يمكن أن يكون بعد تاريخ النهاية.'
        : 'From date cannot be after To date.';

      createdFromDateError = message;
      createdToDateError = message;
    }
  }


  if (modifiedFrom) {
    const fromDate = new Date(modifiedFrom);

    if (fromDate > today) {
      modifiedFromDateError = isArabic
        ? 'لا يمكن اختيار تاريخ مستقبلي.'
        : 'Future dates cannot be selected.';
    }
  }

  // Modified To
  if (modifiedTo) {
    const toDate = new Date(modifiedTo);

    if (toDate > today) {
      modifiedToDateError = isArabic
        ? 'لا يمكن اختيار تاريخ مستقبلي.'
        : 'Future dates cannot be selected.';
    }
  }

  // Modified From > Modified To
  if (modifiedFrom && modifiedTo) {
    const fromDate = new Date(modifiedFrom);
    const toDate = new Date(modifiedTo);

    if (fromDate > toDate) {
      const message = isArabic
        ? 'تاريخ البداية لا يمكن أن يكون بعد تاريخ النهاية.'
        : 'From date cannot be after To date.';

      modifiedFromDateError = message;
      modifiedToDateError = message;
    }
  }

  return {
    createdFromDateError,
    createdToDateError,
    modifiedFromDateError,
    modifiedToDateError,
    isValid:
      !createdFromDateError &&
      !createdToDateError &&
      !modifiedFromDateError &&
      !modifiedToDateError,
  };
}
